var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.089 9.311c.097.205.158.453.158.817 0 .666-.465 1.643-.843 2.264l-.403-3.285-1.668.16.764 4.617h1.904c.834-1.11 1.86-2.69 1.86-3.907 0-.382-.078-.684-.254-.977l-1.518.31v.001zm4.591-.293c-1.737 0-2.58 1.527-2.58 2.966 0 1.11.518 1.998 1.966 1.998.57 0 1.159-.124 1.536-.31l.201-1.386c-.535.275-.947.382-1.377.382-.396 0-.693-.213-.693-.755.895-.009 2.439-.382 2.439-1.598 0-.755-.535-1.297-1.492-1.297zm-.912 2.016c.044-.533.447-.906.754-.906.176 0 .325.106.325.32 0 .444-.773.585-1.08.585zm6.1-2.016c-.623 0-1.062.24-1.395.462l-.018-.382h-1.413l-.746 4.787h1.633l.518-3.357c.14-.071.35-.169.56-.169.16 0 .291.053.291.266 0 .09-.027.25-.035.329l-.457 2.93h1.624l.5-3.197c.027-.168.053-.426.053-.603 0-.64-.29-1.066-1.115-1.066zm7.444 0c-.606 0-1.045.187-1.51.524-.167-.302-.5-.524-1.009-.524-.588 0-1.026.24-1.351.48l-.044-.4h-1.396l-.745 4.787h1.631l.518-3.357c.14-.071.351-.169.562-.169.157 0 .29.053.29.293 0 .062-.018.16-.027.24l-.465 2.993h1.624l.517-3.357c.15-.08.351-.169.553-.169.158 0 .29.053.29.293 0 .062-.018.16-.026.24l-.465 2.993h1.623l.5-3.197c.026-.169.053-.426.053-.604 0-.64-.29-1.066-1.123-1.066zm4.152 0c-1.816 0-2.606 1.412-2.606 2.922 0 1.145.456 2.06 1.834 2.06 1.86 0 2.642-1.545 2.642-3.037 0-1.128-.5-1.945-1.87-1.945zm-.544 3.712c-.29 0-.412-.275-.412-.72 0-.585.131-1.73.772-1.73.29 0 .386.266.386.656 0 .586-.14 1.794-.746 1.794z",
    fill: "#008CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.fe5a3926a7b6670043c16cf1693dd659.svg";
export { ForwardRef as ReactComponent };